import { X } from "lucide-react";
import type { Artwork } from "../types/artwork";
import { formatArtworkPrice, formatAvailability } from "../lib/artworkApi";
import { EnquiryForm } from "./EnquiryForm";

interface ArtworkPanelProps {
  artwork: Artwork | null;
  onClose: () => void;
}

export function ArtworkPanel({ artwork, onClose }: ArtworkPanelProps) {
  if (!artwork) return null;

  return (
    <aside className="artwork-panel" aria-live="polite">
      <button className="icon-button panel-close" type="button" onClick={onClose} aria-label="Close artwork details">
        <X aria-hidden="true" />
      </button>
      <div className="panel-image-wrap">
        {artwork.imageUrl ? (
          <img src={artwork.imageUrl} alt={artwork.title} />
        ) : (
          <div className="panel-placeholder">{artwork.title}</div>
        )}
      </div>
      <p className="eyebrow">{artwork.sku}</p>
      <h2>{artwork.title}</h2>
      <p>{artwork.description || "Artwork details are being prepared."}</p>
      <dl className="artwork-meta">
        <div>
          <dt>Price</dt>
          <dd>{formatArtworkPrice(artwork)}</dd>
        </div>
        <div>
          <dt>Status</dt>
          <dd>{formatAvailability(artwork)}</dd>
        </div>
      </dl>
      <EnquiryForm artwork={artwork} />
    </aside>
  );
}
